module.exports = __webpack_public_path__ + "img/axe_4.896676fa.png";